import { PhoneIcon, SMSIconFilled } from '@rsos/assets/icons';
import { SOURCE_TCAPI } from '@rsos/constants/locationSources';
import {
  EmergencyLocation,
  EmergencyCallSecondaryLocation,
  LocationType,
} from '@rsos/reduxDataStore/src/features/emergencyCalls/emergencyCalls.types';

export const TT911_MESSAGE = 'Text-to-911 Message: Inbound Emergency Request';

export const getToastMessage = (
  callLocation: EmergencyLocation | EmergencyCallSecondaryLocation | null,
) => {
  if (!callLocation) return null;

  if (callLocation.source === SOURCE_TCAPI) {
    return TT911_MESSAGE;
  }

  return null;
};

export const getToastIcon = (locationType: LocationType) => {
  if (locationType === 'sms') {
    return <SMSIconFilled data-name="emergency-calls-toast-sms-icon" />;
  }

  return <PhoneIcon data-name="emergency-calls-toast-phone-icon" />;
};
